module.exports = __webpack_public_path__ + "8d25f8dd9bd4e05909e5d3a31e8c28c5.png";